import React from 'react';
import { Provider } from 'react-redux';
import AuthComp from '../Auth';

const Root = ({ store }) => (
  <Provider store={store}>
    <AuthComp />
  </Provider>
);

export default Root;
